<template>
  <div id="app" class="smooth">
    <div v-if="this.$router.history.current.name != 'login'" class="wrapper">
      <Sidebar />
      <div class="content">
        <Navbar />
        <div class="content-body p-4 scroll-bar smooth" onscroll="sc()">
          <router-view />

          <!-- <div class="sticky-anchor"></div> -->
        </div>
      </div>
    </div>
    <div v-else>
      <router-view />
    </div>
  </div>
</template>
<script>
import Sidebar from "@/components/sidebar";
import Navbar from "@/components/navbar";

export default {
  components: {
    Sidebar,
    Navbar,
  },
};
</script>
<style lang="scss">
.input-secondary-light {
  background: unset !important;
}
.spinner-grow {
  width: 1.5rem !important;
  height: 1.5rem !important;
}
.smooth {
  scroll-behavior: smooth;
}
</style>
